var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('svg',{style:({width: `${_vm.params.width}px`, height: `${_vm.params.height}px`}),attrs:{"id":_vm.params.svgName}}),_c('div',{staticClass:"tooltip",staticStyle:{"opacity":"0"},attrs:{"id":`${_vm.params.svgName}_toolTip`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }